<script>
export default {
  name: "CatalogFliter",
  props: {
    initalOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.initalOpen,
      height: 0,
      overflow: "hidden",
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.update();
    },
    update() {
      const height = this.$refs.content.offsetHeight;
      if (this.isOpen) {
        this.height = height + "px";

        setTimeout(() => {
          this.overflow = "visible";
        }, 300);
      } else {
        this.height = 0;
        this.overflow = "hidden";
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.update();
    }, 200);
  },
};
</script>

<template>
  <div class="products-page-filter">
    <div class="filter-title" :class="{ open: isOpen }" @click="toggle">
      <slot name="title" />
      <icon-arrow-dropdown></icon-arrow-dropdown>
    </div>
    <div
      class="filter-content-wrap"
      :style="{ height: height, overflow: overflow }"
    >
      <div class="filter-content" ref="content">
        <slot name="default" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.products-page-filter {
  border-bottom: 1px solid $color-border;
}

.filter-title {
  @include flex-row;
  align-items: center;
  justify-content: flex-start;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  padding: 16px var(--page-margin) 16px 35px;
  cursor: pointer;
  transition: padding-top 0.3s;

  .svg-icon {
    margin: -15px 0 -15px auto;
    transform: rotate(180deg);
    transition: transform 0.3s;
  }

  &.open {
    padding-top: 25px;
    .svg-icon {
      transform: rotate(360deg);
    }
  }
}

.filter-content-wrap {
  overflow: hidden;
  transition: height 0.3s;
}

.filter-content {
  padding: 0 var(--page-margin) 20px 35px;
}
</style>
